import { Configuration } from 'vendor-marketplace-shared-library';

export const getConfigurationValue = (configuration: Configuration) => {
  return JSON.parse(configuration?.value ?? '{}')?.data;
};

export function isDateWithin24Hours(targetDate: Date) {
  const formattedDate = new Date(targetDate);
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - formattedDate.getTime();
  const hoursDifference = timeDifference / (1000 * 60 * 60);
  return hoursDifference < 24;
}
